import { Role } from '@things-factory/auth-base'

import { Tutorial, TutorialRole } from '../../../entities'

const crypto = require('crypto')

export const updateRoleTutorial = {
  async updateRoleTutorial(_: any, { tutorialId, tutorialRoles }, context: ResolverContext) {
    try {
      const { tx, domain } = context.state

      const tutorial: Tutorial = await tx.getRepository(Tutorial).findOne({
        where: { id: tutorialId }
      })
      if (!tutorial) throw new Error('Tutorial not exist')

      // 1. Delete every tutorial roles related with current tutorial.
      await tx.getRepository(TutorialRole).delete({ id: tutorial.id })

      // 2. Append new role into tutorial roles.
      tutorialRoles.forEach(async (tutorialRole: TutorialRole) => {
        await tx.getRepository(TutorialRole).insert({
          name: crypto.randomUUID(),
          domain,
          tutorial: tutorialId,
          role: await tx.getRepository(Role).findOneBy({ id: tutorialRole.role.id })
        })
      })

      const tutorials = await tx.getRepository(Tutorial).find()
      const rolesTutorial = await tx
        .getRepository(TutorialRole)
        .find({ where: { id: tutorial.id }, relations: ['tutorial'] })
      return tutorials.map((tutorial: Tutorial) => {
        return {
          name: tutorial.name,
          domain,
          tutorial: tutorial.id,
          assigned:
            rolesTutorial.filter((tutorialRole: TutorialRole) => tutorialRole.tutorial.id === tutorial.id).length > 0
        }
      })
    } catch (e) {
      throw e
    }
  }
}
